export const getAuthParams = url => {
  const usp = new URLSearchParams(url)
  const l = usp.get('l')
  const lt = usp.get('lt')

  return {
    seckey: usp.get('sc'),
    redirectTo: usp.get('r'),
    list: l !== null ? parseInt(l) : null,
    loginType: lt !== null ? parseInt(lt) : null,
    smtpPlusUsers: parseInt(usp.get('smtpplususers'), 10) || 0
  }
}
